export default __webpack_public_path__ + "static/media/facility_03_1.4c8fc6c0.png";